<!--<button mat-raised-button color="primary" class="primary">Primary</button>-->


<div class="container" *ngIf="ssoIds.length === 0 || forceEmailLogin">
    <mat-grid-list cols="1" rowHeight="{{100 | px2rem}}">
        <mat-grid-tile>
            <div class="header_logo"><img class="header_logo" src="assets/images/logo.svg?v3" alt=""></div>
        </mat-grid-tile>
    </mat-grid-list>

    <mat-grid-list cols="{{col}}" rowHeight="70vh">
        <mat-grid-tile>
            <div class="login_section">
                <div class="title">Start Trading</div>
                <div class="secondary-title">Login to your account below</div>
                <div class="login-form">
                    <div class="login-card">
                        <div class="login-content">
                          <mat-form-field color="primary">
                            <mat-label>EMAIL</mat-label>
                            <input matInput [formControl]="email" required>
                            <mat-error *ngIf="email.invalid">{{getEmailErrorMessage()}}</mat-error>
                          </mat-form-field>

                          <div style="height: 0; border-bottom: 1px solid #f7f7f7;"></div>

                          <mat-form-field>
                            <mat-label>PASSWORD</mat-label>
                            <input type="password" matInput [formControl]="password" (keyup.enter)="actionLogin()" required>
                            <mat-error *ngIf="password.invalid">{{getPasswordErrorMessage()}}</mat-error>
                          </mat-form-field>
                        </div>
                        <div class="remember-me-section">
                            <div class="trust-device">
                                <mat-checkbox color="primary" [(ngModel)]="isTrustDevice">Trust this device for 30 days</mat-checkbox>
                            </div>

                            <div class="remember-me" style="display: none">
                                <mat-checkbox color="primary">Remember me</mat-checkbox>
                            </div>
                            <div class="forgot-password" (click)="openDialog('forget')">Forgot password</div>

                        </div>
                    </div>

                </div>



                <div class="action-section">
                    <button mat-raised-button class="rubii-btn" color="primary" (click)="actionLogin()"><span style="margin: 0 1rem">{{logging?'Logging in...': 'Login'}}</span></button>
<!--                    <button mat-stroked-button color="primary" class="rubii-btn secondary" (click)="openDialog('join')">Join the waitlist</button>-->
                </div>
            </div>
        </mat-grid-tile>
        <mat-grid-tile *ngIf="col>1">
            <div class=""><img class="login_splash" src="assets/images/login_screen_splash.svg" alt=""></div>
        </mat-grid-tile>
    </mat-grid-list>
</div>
<app-sso [dspIds]="ssoIds" *ngIf="ssoIds.length > 0 && !forceEmailLogin" (switchToEmail)="forceEmailLogin = true"></app-sso>